import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { PrivacyPolicyContent, TermsOfServiceContent } from './LegalContent';
export function Footer() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);
  return <>
      <footer className="bg-black text-gray-400 py-12 border-t border-gray-800" data-id="element-13">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-14">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-15">
            <div className="col-span-1 md:col-span-2" data-id="element-16">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-17">ProstaVive</h3>
              <p className="mb-6 max-w-md" data-id="element-18">
                The most potent, fast-acting formula for prostate health. Made
                with natural ingredients to support your vitality and
                well-being.
              </p>
              <div className="text-sm" data-id="element-19">
                © {new Date().getFullYear()} HEALTHPRODUCTSGURU. All rights
                reserved.
              </div>
            </div>

            <div data-id="element-20">
              <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-21">
                Links
              </h4>
              <ul className="space-y-2" data-id="element-22">
                <li data-id="element-23">
                  <button onClick={() => setShowPrivacyPolicy(true)} className="hover:text-[#4CAF50] transition-colors text-left" data-id="element-24">
                    Privacy Policy
                  </button>
                </li>
                <li data-id="element-25">
                  <button onClick={() => setShowTermsOfService(true)} className="hover:text-[#4CAF50] transition-colors text-left" data-id="element-26">
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-800 text-xs text-justify leading-relaxed opacity-60" data-id="element-27">
            <p className="mb-4" data-id="element-28">
              Disclaimer: The content of this site is for informational purposes
              only, and is not intended to replace professional medical advice,
              diagnosis or treatment. Always seek the advice of your physician
              or other qualified health care professional about a medical
              condition, a suspected medical condition, and before starting a
              diet, exercise, or supplementation program or take or stop a
              medication.
            </p>
            <p data-id="element-29">
              The statements on this website have not been evaluated by the Food
              and Drug Administration. This product is not intended to diagnose,
              treat, cure, or prevent any disease.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)} title="Privacy Policy" data-id="element-30">
        <PrivacyPolicyContent data-id="element-31" />
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={showTermsOfService} onClose={() => setShowTermsOfService(false)} title="Terms of Service" data-id="element-32">
        <TermsOfServiceContent data-id="element-33" />
      </Modal>
    </>;
}